<a class="list-left w-40 block avatar">
  <cc-avatar
    [avatarUrl]="user.avatarUrl"
    avatarSize="medium"
    [fullName]="userFullName"
  ></cc-avatar>
  <i class="b-white bottom" [ngClass]="classBasedOnUserState"></i>
</a>
<a class="user-personal-data">
  <div class="user-username">{{userFullName}}</div>
  <div class="grey-text">{{user.username}}</div>
</a>
